import React from "react";
import SupportQuestionMark from "../../../supportbeacon/SupportQuestionMark";

interface Props {
  articleId: number
  className?: string
}

const PanelSegmentQuestionMark = (props: Props) => {
  return (props.articleId) && <div className={props.className}>
    <SupportQuestionMark articleId={props.articleId} />
  </div>;
};

export default PanelSegmentQuestionMark;
